"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var classnames_1 = __importDefault(require("classnames"));

var lodash_1 = require("lodash");

var react_1 = __importStar(require("react"));

var react_popper_1 = require("react-popper");

var index_1 = __importDefault(require("../../ClickOutside/index"));

var index_2 = __importStar(require("../../Icon/index"));

var FilterItemBody_1 = __importDefault(require("./FilterItemBody"));

var FilterItem =
/** @class */
function (_super) {
  __extends(FilterItem, _super);

  function FilterItem(props) {
    var _this = _super.call(this, props) || this;

    _this.openDialog = function (e) {
      if (e.nativeEvent.outside && e.nativeEvent.outside === _this.props.id) {
        return;
      }

      _this.setState({
        openDialog: true
      });
    };

    _this.closeDialog = function () {
      _this.setState({
        openDialog: false
      });
    };

    _this.changeFilters = function () {
      _this.props.onChange(_this.props.id, _this.state.selectedValues, _this.props.operator ? _this.props.operator : FilterItem.defaultOperator);

      _this.closeDialog();
    };

    _this.selectFilter = function (e) {
      _this.setState({
        filter: e.currentTarget.value
      });
    };

    _this.renderLabel = function () {
      return null;
    };

    _this.renderDropdownBody = function () {
      return null;
    };

    _this.state = {
      selectedValues: props.selected,
      openDialog: false,
      filter: ''
    };
    return _this;
  }

  FilterItem.prototype.componentDidUpdate = function (prevProps) {
    if (prevProps.selected !== this.props.selected) {
      this.setState({
        selectedValues: this.props.selected
      });
    }
  };

  FilterItem.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        className = _a.className,
        inTableHeader = _a.inTableHeader,
        id = _a.id,
        operator = _a.operator,
        type = _a.type;
    var _b = this.state,
        selectedValues = _b.selectedValues,
        openDialog = _b.openDialog;
    var cn = classnames_1.default('emankit__filter_bar__item', className);

    if (operator && this.validOperators.indexOf(operator) === -1) {
      // tslint:disable-next-line:max-line-length
      throw new Error("Cannot use \"" + operator + "\" operator with filter type \"" + type + "\". Allowed operators are: \"" + this.validOperators.toString() + "\"");
    }

    var filterLabel;

    if (inTableHeader) {
      filterLabel = react_1.default.createElement("span", {
        className: 'rectangle ' + (selectedValues && lodash_1.castArray(selectedValues).length ? 'selected' : ''),
        onClick: this.openDialog
      }, react_1.default.createElement(index_2.default, {
        icon: index_2.IconType.Filter,
        width: 12,
        height: 10
      }));
    } else {
      filterLabel = this.renderLabel();
    } // tslint:disable:max-line-length


    return react_1.default.createElement("div", {
      className: cn
    }, react_1.default.createElement(react_popper_1.Manager, null, react_1.default.createElement(react_popper_1.Reference, null, function (_a) {
      var ref = _a.ref;
      return react_1.default.createElement("div", {
        ref: ref
      }, filterLabel);
    }), react_1.default.createElement(index_1.default, {
      onClickOutside: this.closeDialog,
      disabled: !openDialog,
      id: Array.isArray(id) ? id.toString() : id
    }, react_1.default.createElement(react_popper_1.Popper, {
      placement: "bottom-start",
      positionFixed: true,
      modifiers: {
        preventOverflow: {
          enabled: true,
          boundariesElement: 'window'
        }
      }
    }, function (_a) {
      var ref = _a.ref,
          style = _a.style,
          placement = _a.placement,
          scheduleUpdate = _a.scheduleUpdate;
      return react_1.default.createElement(FilterItemBody_1.default, {
        open: openDialog,
        placement: placement,
        style: style,
        innerRef: ref,
        scheduleUpdate: scheduleUpdate
      }, _this.renderDropdownBody());
    }))));
  };

  FilterItem.defaultProps = {
    single: false
  };
  FilterItem.defaultOperator = 'in';
  return FilterItem;
}(react_1.Component);

exports.default = FilterItem;